import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { InitialUserStateType } from 'entities/user/model/types';
import { userSlice } from 'entities/user';
import { InitialAppStateType } from 'entities/app/table/types/appTypes';
import { appTableSlice } from 'entities/app/table';

import { ModalInitialState, modalReducer } from 'entities/modal';
import { orderReducer, OrdersStateType } from 'entities/order';
import { engineReducer, EnginesStateType } from 'entities/engine';
import { feedbackReducer, FeedbacksStateType } from 'entities/feedback';
import { usersReducer, UsersStateType } from 'entities/users';
import { formalizedZipReducer, FormalizedZipsStateType } from 'entities/formalizedZip';
import { unFormalizedZipReducer, UnFormalizedZipStateType } from 'entities/unFormalizedZip';
import { engineMeasurementReducer, EngineMeasurementsStateType } from 'entities/engineMeasurement';
import { errorHandlingMiddleware } from '../lib/errorHandlingMiddlware';

const appReducer = combineReducers({
  [appTableSlice.name]: appTableSlice.reducer,
});

export interface IStore {
  appReducer: InitialAppStateType;
  userSlice: InitialUserStateType;
  modalReducer: ModalInitialState;
  orders: OrdersStateType;
  engines: EnginesStateType;
  feedbacks: FeedbacksStateType;
  users: UsersStateType;
  formalizedZips: FormalizedZipsStateType;
  unFormalizedZips: UnFormalizedZipStateType;
  engineMeasurement: EngineMeasurementsStateType;
}

export const store = configureStore({
  reducer: combineReducers({
    appReducer,
    userSlice,
    modalReducer,
    orders: orderReducer,
    engines: engineReducer,
    feedbacks: feedbackReducer,
    users: usersReducer,
    formalizedZips: formalizedZipReducer,
    unFormalizedZips: unFormalizedZipReducer,
    engineMeasurement: engineMeasurementReducer,
  }),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  })
    .concat(errorHandlingMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
